import React, { FC, useState, useEffect, memo, useContextSignal, createContext, Context } from "../../../lib/teact/teact";
import { getCurrentTimeMillis } from "../utils/DateTimeUtils";
import Loginone789 from "./loginone789";
import { IdTokenGlobal, OneAPi, setIdTokenGlobal } from "./oneApi";
import { OneProfile, UserAccount } from "./oneTypes";
import PlayOne789, { ChatContextType, oneMenuId, PlayOne789Context } from "./playOne789";


type OwnProps = {
    mainWorkingState: any;
    onUpdateState: (curState: any) => void;
}
const One789Main: FC<OwnProps> = ({
    mainWorkingState,
    onUpdateState,
}) => {

    const savedObj = getOne789Sign();
    const [state, setState] = useState({
        IdToken: savedObj ? savedObj.logedinResult.IdToken : mainWorkingState.one789.IdToken,
        ExpireTimeStamp: mainWorkingState.one789.ExpireTimeStamp,
        profile: initProfile(),
        isLogedIn: false,
        hideLogin: false,

    });
    function getOne789Sign(): any {
        const savedStr = localStorage['one789sign']
        if (savedStr) {
            const savedObj = JSON.parse(savedStr);
            setIdTokenGlobal(savedObj.logedinResult.IdToken);
            return savedObj;
        } else {
            return undefined;
        }
    }
    useEffect(() => {
        //kiểm tra tokens lần đầu tiên vào
        /* {
            "message": "The incoming token has expired"
        } */
        OneAPi.profile().then(res => {
            if (res && res.message && res.res.message == 'The incoming token has expired') {
                setState(prev => ({ ...prev, hideLogin: false }))
                return;
            } else if (res) { // call được api tức là đã login và token còn hiệu lực
                const pr = structuredClone(res);
                setState(prev => ({
                    ...prev, profile: { ...prev.profile, profile: pr }, isLogedIn: true,
                    hideLogin: true
                }))
            }
        })
    }, [])
    function initProfile(): OneProfile {

        const userAccount: UserAccount = {
            Username: "",
            Level: 0,
            Path: "",
            FullName: "",
            Balance: 0,
            CreditLimit: 0,
            PaymentMethod: 0,
            PlayerPaymentDates: [],
            Products: []
        }
        const ret: OneProfile = {
            profile: userAccount,
            recentBets: []
        }
        return ret;
    }
    //  const { showAlert } = useContextSignal<ChatContextType>(PlayOne789Context);
    async function handleLogedin(logedInresult: any) {
        const expiresIn = getCurrentTimeMillis() + logedInresult.ExpiresIn * 1000 - 10000;
        setState(prev => ({
            ...prev, IdToken: logedInresult.IdToken,
            ExpireTimeStamp: expiresIn,

        }))
        if (onUpdateState) {
            const profile: UserAccount = await OneAPi.profile();
            setState(prev => ({ ...prev, isLogedIn: true, profile: { ...state.profile, profile } }))
            onUpdateState({
                IdToken: logedInresult.IdToken, ExpireTimeStamp: expiresIn,
                profile: { ...state.profile, profile },
                isLogedIn: true,
            });
        }

    }
    function handelOnHideLogin(hide: boolean) {
        setState(prev => ({ ...prev, hideLogin: hide }))
    }
    function handleOnMenuClick(id: oneMenuId) {
        switch (id) {
            case 'Relogin':
                setState(prev => ({ ...prev, hideLogin: false }))
                break;
            case 'SaoKe':
                break;
        }
    }
    return <div>
        {
            //getCurrentTimeMillis() >= state.ExpireTimeStamp &&
            <Loginone789 onLogedIn={handleLogedin} hideLogin={state.hideLogin}
                onHideLogin={handelOnHideLogin} />
        }
        {/* {showAlert()} */}
        {state.isLogedIn &&
            <PlayOne789 mapResult={mainWorkingState.one789.mapResult}
                profile={state.profile}
                mainWorkingState={mainWorkingState}
                onMenuClick={handleOnMenuClick} />
        }
    </div>
}

export default memo(One789Main);